import api from "@/api"
import { getBlocklist, isItemBlocked } from "@/services/blocklist-service"
import notify from "@/utils/notify"

const state = () => ({
  categories: [],
  blocklist: []
})

const getters = {
  availableCategories: (state) => {
    return state.categories.filter((category) => !isItemBlocked(state.blocklist, "category", category.id))
  },
  blocklist: (state) => {
    return state.blocklist
  }
}

const mutations = {
  setCategories: (state, payload) => {
    state.categories = payload
  },
  setBlocklist: (state, payload) => {
    state.blocklist = payload
  }
}

const actions = {
  loadCategories: async ({ commit }) => {
    try {
      commit("setCategories", (await api.categories.index()).categories)
    } catch (_) {
      notify("Failed to fetch categories from API (e.g. for header)!")
    }
  },
  ensureBlocklistIsPresent: async ({ commit, rootGetters }) => {
    commit("setBlocklist", await getBlocklist({ isLoggedIn: rootGetters.isUserLoggedIn }))
  },
  loadAvailableCategories: async ({ dispatch }) => {
    await Promise.all([dispatch("loadCategories"), dispatch("ensureBlocklistIsPresent")])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
